import React, { useEffect } from "react";
import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";

import LoadingComponent from "../../../components/Loading";

import { useSelector } from "react-redux";

import { selectUsuarioSeleccionado } from "../../../redux/reducer/loginReducer";
import TituloPagina from "../../../components/Titulos/TituloPagina";
import { getCmiAntiguosAlumnos, getRetencionTutores } from "../../../services/alumnos";
import {
  Box,
  Button,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  CircularProgress,
  Table,
  Link,
} from "@material-ui/core";
import { GaugeComponent } from "react-gauge-component";
import { set } from "date-fns";
import { green, grey, red, yellow } from "@material-ui/core/colors";

/* -------------------------------------------------------------------------- */
/*                                   Estilos                                  */
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: "80px",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "90vh",
  },
  emptyContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    width: "100%",
    flexDirection: "column",
    textAlign: "center",
  },
  emptyImage: {
    width: "100%",
  },
  rootFilter: {
    padding: theme.spacing(0.5, 0.5, 0),
    justifyContent: "space-between",
    display: "flex",
    alignItems: "flex-start",
    flexWrap: "wrap",
  },
  textFieldFilter: {
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    margin: theme.spacing(1, 0.5, 1.5),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(0.5),
    },
    "& .MuiInput-underline:before": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  enlace: {
    color: theme.palette.link.main,
    textDecoration: "none",
  },
}));

export default function RetencionTutoresContent() {
  const classes = useStyles();

  const [loading, setLoading] = useState(false);
  const [loadingMensaje, setLoadingMensaje] = useState("");

  // const [antiguosAlumnos, setAntiguosAlumnos] = useState([]);
  // const [numAntiguosAlumnos, setNumAntiguosAlumnos] = useState(0);
  // const [datosMelani, setDatosMelani] = useState([]);
  // const [datosJennifer, setDatosJennifer] = useState([]);

  const usuarioSeleccionado = useSelector((state) => {
    return selectUsuarioSeleccionado(state);
  });

  /* -------------------------------------------------------------------------- */
  /*                                  UseEffect                                 */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    // setLoading(true);
    // setLoadingMensaje("Cargando datos");

    const usuario_id = usuarioSeleccionado.id;

    getRetencionTutores({
      usuario: usuario_id,
      nombre_dato: "estadisticas",
    }).then((response) => {
      setLoading(false);
      setLoadingMensaje("");

      console.log(response)
    //   setAntiguosAlumnos(response.antiguos_alumnos);

    //   setNumAntiguosAlumnos(response.num_antiguos_alumnos);

    //   setDatosMelani(response.resultado.filter((item) => item.id === "9"));
    //   setDatosJennifer(response.resultado.filter((item) => item.id === "15" ));

    });
  }, []);


  /* -------------------------------------------------------------------------- */
  /*                                  Contenido                                 */
  /* -------------------------------------------------------------------------- */

  const Contenido = () => {
    return (
      <>
        <TituloPagina titulo={"Retención tutores"} />

      </>
    );
  };

  /* -------------------------------------------------------------------------- */
  /*                                   Return                                   */
  /* -------------------------------------------------------------------------- */
  return (
    <div className={classes.container}>
      {loading ? (
        <LoadingComponent isFullScreen={true} mensaje={loadingMensaje} />
      ) : (
        <Contenido />
      )}
    </div>
  );
}

const CardIndicador = ({titulo, valor}) => {
  return (
    <Card style={{ marginBottom: "20px"}}>
      <CardContent>
        <Grid item>
          <Typography variant="h5" component="div" gutterBottom style={{ color: grey[400]}}>
            {titulo}
          </Typography>
          <Typography variant="h3" color="textSecondary" style={{ fontWeight: "bold", textAlign: "right"}}>
            {valor}
          </Typography>
        </Grid>
      </CardContent>
    </Card>
  )
}
